export const accountBG = {
    "myAccount": "Моят акаунт",
    "profile": "ПРОФИЛ",
    "addresses": "АДРЕСИ",
    "history": "ИСТОРИЯ",
    "comments": "ОТЗИВИ",
    "settings": "НАСТРОЙКИ",
    "psw": "Смяна на парола",
    "updateAlert": "Данните ви бяха успешно актуализирани",
    "updateError": "Грешка при актуализиране",
    "registerToEdit": "Влезте или се регистрирайте, за да запазите данните си.",
    "addAddress": "Добави адрес",
    "addNewAddress": "Добави нов адрес",
    "myLocation": "Моето местоположение",
    "modalHeaderUpdate": "Промяна на адрес",
    "otherLocation": "Друг адрес",
    "home": "Дом",
    "work": "Работа",
    "helperText": "Моля въведете данните за адреса",
    "addressComments": "Допълнителни бележки за адреса",
    "historyPlaceholder": "Все още нямате направени покупки",
    "commentPlaceholder": "Все още нямате направени отзиви",
    "emptyHistory": "Все още нямате направени поръчки.",
    "uploadAvatar": "Кликнете върху снимката, за да изберете друга.",
    "submit": "ИЗПРАТИ",
    "uploadSuccess": "Файлът е качен успешно",
    "uploadError": "Грешка при качване на файл",
    "bigFile": "Снимката е твърде голяма. Трябва да бъде до 1MB. Моля изберете по-малка снимка.",
    "favorites": "Моите любими",
    "hello": "Здравейте",
    "profileHeader": "Профил",
    "settingsSmall": "Настройки",
    "newPassword": "Нова парола",
    "repeatNewPassword": "Повторете новата парола",
    "passwordChangeSuccess": "Паролата е успешно променена",
    "passwordChangeError": "Неуспешна смяна на паролата, ",
    "passwordMismatch": "Повторената парола не съвпада"
}
